;(function($){

    function Contract_supplier() {
        var _ = this;
        _.API          = $("#app_url").val() + "/api/";

        $(".btn-delete-nfe-anex").on("click", function(e){  
 
            var url =  $(this).data('url'); 
            swal({
              title: 'Deseja realmente excluir essa Nota Fiscal?',
              text: "Não será possivel a recuperação do mesmo.",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              cancelButtonText: 'Cancelar', 
              confirmButtonText: 'Sim'
            }).then(function () {
                window.location.href = url; 
            });
        });

        $("#value").on("change", function(e){
            e.preventDefault();
            _.calcValue();
        });

        $("#value_hours").on("change", function(e){
            e.preventDefault();
            _.calcValueHours();
        });

        $("#number_hours").on("change", function(e){
            e.preventDefault();
            _.calcNumbersHours();
        });

        $("#start_validity").on("focusout", function(e){
            e.preventDefault();

            if($(this).val() > $("#end_validity").val()) {
                swal({
                    title: "OPS",
                    text: "A data de inicio é maior que a data final, corrija a informação!",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Fechar!",
                    closeOnConfirm: false
                }); 
            }else {
                _.projection();
            }
        });

        $("#end_validity").on("focusout", function(e){
            e.preventDefault();

            if($(this).val() < $("#start_validity").val()) {
                swal({
                    title: "OPS",
                    text: "A data final é menor que a data inicial, corrija a informação!",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Fechar!",
                    closeOnConfirm: false
                }); 
            }else {
                _.projection();
            }
        });

        $("#payday").on("focusout", function(e){
            e.preventDefault();
            _.projection();
        });

        $("#contract-supplier-legend").on("click", function(e){
            e.preventDefault();

            swal({
              type: 'info',
              html: '<div style="text-align: left; max-width: 150px; margin: 0 auto;"><i class="fa fa-circle" style="color: #c33434;"></i> Em Aberto </br><i class="fa fa-circle" style="color: #4db300;"></i> Pago </br></div>',
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonColor: '#0b7789',
              confirmButtonText: 'Fechar'
            });
        });

        if($("#modal-upload-nfe").length > 0) {

            $("#modal-upload-nfe").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();   
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    _.html = '<form id="form-upload-nfe" enctype="multipart/form-data">'+
                   '<div class="row">' + 
                   '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                       '<div class="form-row">' +
                           '<label for="contract_supplier_payment_projection_id">Registro</label>' +
                           '<input type="text" id="contract_supplier_payment_projection_id" name="contract_supplier_payment_projection_id" value="'+  _.contract_supplier +'" readonly>' +
                       '</div>'+
                   '</div>'+
                   '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                   '<div class="form-row">' +
                       '<label for="number_nf">Número da NFe</label>' +
                       '<input type="text" id="number_nf" name="number_nf" onkeypress="return event.charCode >= 48 && event.charCode <= 57">' +
                   '</div>'+
               '</div>'+
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="value">Valor da NFe (Nota Fiscal)</label>' +
                                '<input type="text" id="value" name="value" data="data-money" value="' + _.value_nfe + '">' + 
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="portion">Parcela</label>' +
                                '<input type="text" id="portion" name="portion" value="'+ _.portion  +'" readonly>' +
                            '</div>'+
                        '</div>'+  
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="due_date">Data de Emissão da NFe</label>' +
                                '<input type="date" id="date_of_issue" name="date_of_issue">' +
                            '</div>'+
                        '</div>'+                            
                   '</div>'+                  
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="file">NFe (Nota Fiscal)</label>' + 
                                '<input type="file" id="file" name="file" data="upload">' +
                            '</div>'+
                        '</div>'+                             
                   '</div>' +
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                            '<input type="hidden" id="providers_id" name="providers_id" value="'+_.providers_id+'">' + 
                            '<input type="hidden" id="portion" name="portion" value="'+_.portion+'">' + 
                            '<input type="hidden" id="due_date" name="due_date" value="'+_.due_date+'">' + 
                                '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                            '</div>'+
                        '</div>'+                             
                   '</div></form>';

                    if(_.html != ""){
                    $('#modal-upload-nfe').iziModal('setTitle', 'Adicionar Nota Fiscal');
                    $("#modal-upload-nfe .content").html(_.html);
                    
                    $(document).find('input[data="data-money"]').mask('000.000.000.000.000,00', {reverse: true});

                    _.myForm = $("#form-upload-nfe").validate({
                        rules: { 
                            number_nf: { required: true },
                            date_of_issue: { required: true },
                            file: { required: true}
                        },
                        messages: { 
                            number_nf: { required: "Campo Obrigatório" },
                            date_of_issue: { required: "Campo Obrigatório" },
                            file: { required: "Campo Obrigatório"}
                        },
                        invalidHandler: function(e) {
                            swal({
                                title: "Atenção!",
                                text: "Preencha todos os campos.",
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "OK!",
                                closeOnConfirm: true
                            });

                        },
                        submitHandler: function( form ) {
                        
                            $("#form-upload-nfe .btn-send").html("Enviando...");
                            
                            $.ajax({
                                type: "POST",
                                url: _.API + "contratos-fornecedores/editar/"+_.contract_supplier,
                                cache: false,
                                contentType: false,
                                processData: false,
                                data: new FormData(form),
                                success: function(result)
                                {
                                    $("#form-upload-nfe .btn-send").html("Enviar");

                                    form.reset();

                                    $('#modal-upload-nfe').iziModal('close'); 

                                    swal({
                                        title: result.message,
                                        text: "Click no botão para fechar!",
                                        type: "success",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Fechar!",
                                        closeOnConfirm: false
                                    }).then(function() {
                                      location = location+"#documentos";

                                      location.reload(true);
                                    });                                        
                                },
                                error: function(response) {
                                    var errors = $.parseJSON(response.responseText);
                                    
                                    swal({
                                        title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                        text: "Click no botão para fechar!",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "Fechar!",
                                        closeOnConfirm: true
                                    });

                                   
                                    $myForm.showErrors(errors);
                                    
                                    $("#form-upload-nfe .btn-send").html("Enviar");
                                }
                            });
                        }
                    });
                }                
                },
                onClosed: function() {
                    _.uri          = null;
                    _.providers_id = null;
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-upload-nfe .content").html("");
                    $('#modal-upload-nfe').iziModal('setTitle', "");
                }        
            });
        }

        $("button.btn-upload-nfe ").on("click", function(e){
            e.preventDefault();
            _.providers_id = $(this).data('provider');
            _.contract_supplier = $(this).data('contract-supplier');
            _.value_nfe = $(this).data('value');
            _.portion = $(this).data('portion');
            _.due_date = $(this).data('due-date');
            
            $('#modal-upload-nfe').iziModal('open');           
        });

    }
    Contract_supplier.prototype.deleteNfeAnex = function ()
    {
        var _ = this;
    }
    Contract_supplier.prototype.calcValue = function(){
        var _            = this;
        var nValue       = $("#value").val();
        var nValueHours  = $("#value_hours").val();
        var nNumberHours = $("#number_hours").val();

        nValue       = (!nValue) ? 0 : nValue;
        nValueHours  = (!nValueHours) ? 0 : nValueHours;
        nNumberHours = (!nNumberHours) ? 0 : nNumberHours;

        nValue       = nValue.toString();
        nValueHours  = nValueHours.toString();
        nNumberHours = nNumberHours.toString();

        nValue       = nValue.replace('.','');
        nValueHours  = nValueHours.replace('.','');
        nNumberHours = nNumberHours.replace('.','');

        nValue       = nValue.replace(',','.');
        nValueHours  = nValueHours.replace(',','.');
        nNumberHours = nNumberHours.replace(',','.');

        nValue       = parseFloat(nValue);
        nValueHours  = parseFloat(nValueHours);
        nNumberHours = parseFloat(nNumberHours);

        nValue       = nValue.toFixed(2);
        nValueHours  = nValueHours.toFixed(2);
        nNumberHours = nNumberHours.toFixed(2);


        _.value_hours  = (nValue / nNumberHours);
        
        _.value        = parseFloat(_.value);
        _.value_hours  = parseFloat(_.value_hours);
        _.number_hours = parseFloat(_.number_hours);

        _.value        = _.value.toFixed(2);
        _.value_hours  = _.value_hours.toFixed(2);
        _.number_hours = _.number_hours.toFixed(2);

        _.value        = _.value.toString();
        _.value_hours  = _.value_hours.toString();
        _.number_hours = _.number_hours.toString();

        _.value        = _.value.replace('.',',');
        _.value_hours  = _.value_hours.replace('.',',');
        _.number_hours = _.number_hours.replace('.',',');

        $("#value_hours").val(_.value_hours);
        $(document).find("#value").trigger('input');
        $(document).find("#value_hours").trigger('input');
        $(document).find("#number_hours").trigger('input');

        _.projection();
    }

     Contract_supplier.prototype.calcValueHours = function(){
        var _            = this;
        var nValue       = $("#value").val();
        var nValueHours  = $("#value_hours").val();
        var nNumberHours = $("#number_hours").val();

        nValue       = (!nValue) ? 0 : nValue;
        nValueHours  = (!nValueHours) ? 0 : nValueHours;
        nNumberHours = (!nNumberHours) ? 0 : nNumberHours;

        nValue       = nValue.toString();
        nValueHours  = nValueHours.toString();
        nNumberHours = nNumberHours.toString();

        nValue       = nValue.replace('.','');
        nValueHours  = nValueHours.replace('.','');
        nNumberHours = nNumberHours.replace('.','');

        nValue       = nValue.replace(',','.');
        nValueHours  = nValueHours.replace(',','.');
        nNumberHours = nNumberHours.replace(',','.');

        nValue       = parseFloat(nValue);
        nValueHours  = parseFloat(nValueHours);
        nNumberHours = parseFloat(nNumberHours);

        nValue      = nValue.toFixed(2);
        nValueHours = nValueHours.toFixed(2);

        _.value        = (nValueHours * nNumberHours);
        
        _.value        = parseFloat(_.value);
        _.value_hours  = parseFloat(_.value_hours);
        _.number_hours = parseFloat(_.number_hours);

        _.value        = _.value.toFixed(2);
        _.value_hours  = _.value_hours.toFixed(2);
        _.number_hours = _.number_hours.toFixed(2);

        _.value        = _.value.toString();
        _.value_hours  = _.value_hours.toString();
        _.number_hours = _.number_hours.toString();

        _.value        = _.value.replace('.',',');
        _.value_hours  = _.value_hours.replace('.',',');
        _.number_hours = _.number_hours.replace('.',',');

        $("#value").val(_.value);
        $(document).find("#value").trigger('input');
        $(document).find("#value_hours").trigger('input');
        $(document).find("#number_hours").trigger('input');

        _.projection();
    }

    Contract_supplier.prototype.calcNumbersHours = function(){
        var _            = this;
        var nValue       = $("#value").val();
        var nValueHours  = $("#value_hours").val();
        var nNumberHours = $("#number_hours").val();

        nValue       = (!nValue) ? 0 : nValue;
        nValueHours  = (!nValueHours) ? 0 : nValueHours;
        nNumberHours = (!nNumberHours) ? 0 : nNumberHours;

        nValue       = nValue.toString();
        nValueHours  = nValueHours.toString();
        nNumberHours = nNumberHours.toString();

        nValue       = nValue.replace('.','');
        nValueHours  = nValueHours.replace('.','');
        nNumberHours = nNumberHours.replace('.','');

        nValue       = nValue.replace(',','.');
        nValueHours  = nValueHours.replace(',','.');
        nNumberHours = nNumberHours.replace(',','.');

        nValue       = parseFloat(nValue);
        nValueHours  = parseFloat(nValueHours);
        nNumberHours = parseFloat(nNumberHours);

        nValue       = nValue.toFixed(2);
        nValueHours  = nValueHours.toFixed(2);
        nNumberHours = nNumberHours.toFixed(2);

        _.value        = (nValueHours * nNumberHours);
        _.value_hours  = ( _.value / nNumberHours);
        
        _.value        = parseFloat(_.value);
        _.value_hours  = parseFloat(_.value_hours);        

        _.value        = _.value.toFixed(2);
        _.value_hours  = _.value_hours.toFixed(2);

        _.value        = _.value.toString();
        _.value_hours  = _.value_hours.toString();

        _.value        = _.value.replace('.',',');
        _.value_hours  = _.value_hours.replace('.',',');

        $("#value").val(_.value);
        $(document).find("#value").trigger('input');
        $(document).find("#value_hours").trigger('input');
        $(document).find("#number_hours").trigger('input');

        _.projection();
    }

    Contract_supplier.prototype.projection = function(){
        var _            = this;
        var nValue       = $("#value").val();
        _.start_validity = $("#start_validity").val();
        _.end_validity   = $("#end_validity").val();
        _.payday         = $("#payday").val();

        nValue       = (!nValue) ? 0 : nValue;
        nValue       = nValue.toString();
        nValue       = nValue.replace('.','');
        nValue       = nValue.replace(',','.');
        nValue       = parseFloat(nValue);
        nValue       = nValue.toFixed(2);

        if( _.start_validity == "" || _.end_validity == "" || nValue == 0 || _.payday == "") {
            return false;
        }        
        
        var start_validity = _.start_validity.split('-');
        var date1          = new Date(_.end_validity);
        var date2          = new Date(_.start_validity);
        var diff           = new DateDiff(date1, date2);
        var portion        = parseInt((diff.months()));
        var html           = '';
        var itemValue      = nValue / portion;
        var due_date       = new Date(start_validity[0]+"-"+start_validity[1]+"-"+(parseInt(_.payday) + 1));

        itemValue     = parseFloat(itemValue);
        itemValue     = itemValue.toFixed(2);


        for (var i = 1; i <= portion; i++) {            

            due_date.setMonth((due_date.getMonth() + 1));

            var currentDate = due_date.toLocaleDateString();
            currentDate     = currentDate.split('/');
            currentDate     = currentDate[2]+"-"+currentDate[1]+"-"+currentDate[0];

            html  += '<tr>';
                html += '<td data-label="Status"><i class="fa fa-circle"></i></td>';
                html += '<td data-label="Nº">';
                    html += '<input type="text" name="contract_supplier_payment_projection['+i+'][number]" disabled data-integrate>';
                html += '</td>';
                html += '<td data-label="Parcela"><input type="text" name="contract_supplier_payment_projection['+i+'][portion]" value="'+i+'", data-integrate></td>';
                html += '<td data-label="Valor"><input type="text" name="contract_supplier_payment_projection['+i+'][value]" value="'+itemValue+'" data-money></td>';
                html += '<td data-label="Vencimento"><input type="date" name="contract_supplier_payment_projection['+i+'][due_date]" value="'+currentDate+'"></td>';
                html += '<td data-label="Ações">';
                    html += '<button type="button" class="btn-delete"><i class="fa fa-times-circle" aria-hidden="true"></i></button>';
                html += '</td>';    
            html += '</tr>';
        }

        $("#payment-projection tbody").html(html);
        $(document).find("input[data-money]").mask('000.000.000.000.000,00', {reverse: true});
    }

   	new Contract_supplier();

}(jQuery));